import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const businessAreasSchema: CollectionCreateSchema = {
  name: CollectionName.BusinessAreas,
  fields: [
    {
      name: "search_id",
      type: "string",
    },
    {
      name: "label",
      type: "string",
      facet: false,
      infix: true,
    },
  ],
  visibility: CollectionVisibility.Public,
}
